// src/api/students.js
import toast from "react-hot-toast";
import customFetch from "../hooks/fetchWrapper";

// Update an existing student
export const updateApplciation = async (id, formBody) => {
  return toast.promise(
    customFetch(`application/${id}`, {
      method: "PUT",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Updating Application details...",
      success: (data) => {
        // Assuming the API returns the updated student data
        return data.message || "Application updated successfully";
      },
      error: (err) => err.message || "Failed to update application",
    }
  );
};
